import FrontLayout from './FrontLayout';

export default FrontLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/FrontLayout/index.ts